export default "__VITE_ASSET__Bf39GJAA__"